import { render, staticRenderFns } from "./RoutingTargetActions.vue?vue&type=template&id=49dee0cc"
import script from "./RoutingTargetActions.vue?vue&type=script&lang=js"
export * from "./RoutingTargetActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports